module.exports = __webpack_public_path__ + "static/media/foto4.a361d8d4.png";